import React from "react";

/**
 * Card de parametrização de sinalização de velocidade (urbana e rodoviária).
 */
export default function SpeedConfigCard({ speedForm, onSpeedFormChange, highSpeedOptions }) {
  return (
    <div className="card col-md-12 p-3 mt-3">
      <h5 className="mb-3">Parametrização de sinalização de velocidade definida</h5>

      <div className="row align-items-center g-2 mb-2">
        <div className="col-auto">
          <div className="form-check form-switch">
            <label className="form-check-label" htmlFor="switchUrbano">
              {" "}
              Limite de velocidade Urbana
            </label>
            <input
              className="form-check-input"
              type="checkbox"
              id="switchUrbano"
              checked={speedForm.urban.flag}
              onChange={(e) =>
                onSpeedFormChange((prev) => ({
                  ...prev,
                  urban: { ...prev.urban, flag: e.target.checked },
                }))
              }
            />
          </div>
        </div>
        <div className="col-auto">
          <select
            className="form-control form-control-sm text-center"
            style={{ width: 50 }}
            value={speedForm.urban.value}
            onChange={(e) =>
              onSpeedFormChange((prev) => ({
                ...prev,
                urban: { ...prev.urban, value: e.target.value },
              }))
            }
          >
            {highSpeedOptions.map((num) => (
              <option key={num} value={num}>
                {num}
              </option>
            ))}
          </select>
        </div>
        <div className="col-auto">
          <span className="text-muted small">Km/h</span>
        </div>
      </div>

      <div className="row align-items-center g-2 mb-2">
        <div className="col-auto">
          <div className="form-check form-switch">
            <label className="form-check-label" htmlFor="switchRodovia">
              Limite de velocidade Rodoviária
            </label>
            <input
              className="form-check-input"
              type="checkbox"
              id="switchRodovia"
              checked={speedForm.highway.flag}
              onChange={(e) =>
                onSpeedFormChange((prev) => ({
                  ...prev,
                  highway: { ...prev.highway, flag: e.target.checked },
                }))
              }
            />
          </div>
        </div>
        <div className="col-auto">
          <select
            className="form-control form-control-sm text-center"
            style={{ width: 45 }}
            value={speedForm.highway.value}
            onChange={(e) =>
              onSpeedFormChange((prev) => ({
                ...prev,
                highway: { ...prev.highway, value: e.target.value },
              }))
            }
          >
            {highSpeedOptions.map((num) => (
              <option key={num} value={num}>
                {num}
              </option>
            ))}
          </select>
        </div>
        <div className="col-auto">
          <span className="text-muted small">Km/h</span>
        </div>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: "10px" }} />
    </div>
  );
}
